import React, { Component } from 'react'

class AnimatedTitle extends Component {
    state = {
        startAnimation: false,
        titleArray: this.props.titleArray.slice(0, 2)
    }

    static defaultProps = {
        titleArray: []
    }

    componentDidMount() {
        let nextIndex = 1
        this.intervalId = setInterval(() => {
            const nextArray = this.state.titleArray.slice()
            nextIndex += 1
            if (nextIndex > 2) {
                nextIndex = 0
            }
            nextArray.shift()
            nextArray.push(this.props.titleArray[nextIndex])
            this.setState({
                startAnimation: !this.state.startAnimation
            }, () => {
                this.timeoutId = setTimeout(() => {
                    this.setState({
                        titleArray: nextArray,
                        startAnimation: !this.state.startAnimation
                    })
                }, 1000)
            })
        }, 2000)
    }

    componentWillUnmount() {
        clearInterval(this.intervalId)
        clearTimeout(this.timeoutId)
    }

    render() {
        let moveAnimationClass = ''
        if (this.state.startAnimation) {
            moveAnimationClass = 'animated-title__move'
        }

        const titles = this.state.titleArray.map((val, key) => {
            const splitTitles = val.split(' ')

            return (
                <h1
                    className={'header1 header1--landing'}
                    key={key}
                >
                    <span>{splitTitles[0]} </span>
                    <span className="animated-title__title--white">
                        {splitTitles[1]}
                    </span>
                </h1>
            )
        })

        return (
            <div className="animated-title">
                <div className={moveAnimationClass}>
                    {titles}
                </div>
            </div>
        )
    }
}

export default AnimatedTitle



// WEBPACK FOOTER //
// ./src/scripts/components/AnimatedTItle.jsx